import { Prefill } from '@library/formBuilder/prefill';
import type { AtomModel } from '@models/atom.model';
import type { RichTextData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<RichTextData>;
};

export const RichTextModal = ({ atom }: Props) => (
  <>
    <Prefill atom={atom} />
  </>
);
